import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "w-full min-w-[680px] sm:min-w-0" }
const _hoisted_2 = { class: "col-span-9" }
const _hoisted_3 = { class: "grid grid-cols-12" }
const _hoisted_4 = { class: "flex items-center space-x-2 col-span-2" }
const _hoisted_5 = { class: "truncate text-sm font-semibold text-gray-800" }
const _hoisted_6 = { class: "truncate col-span-3 text-sm font-semibold text-gray-800" }
const _hoisted_7 = {
  key: 1,
  class: "text-sm font-semibold text-gray-800"
}
const _hoisted_8 = { class: "truncate col-span-2 text-sm text-gray-500" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "inline-flex align-middle items-center text-sm tracking-tighter text-gray-800 hover:text-gray-900" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "truncate col-span-3 text-sm text-gray-500" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "inline-flex align-middle items-center text-sm tracking-tighter text-gray-800 hover:text-gray-900" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "truncate col-span-2 text-xs text-gray-900 hover:underline" }
const _hoisted_17 = { class: "px-1.5 py-0.5 rounded-md bg-gray-200 inline-flex align-middle items-center" }
const _hoisted_18 = { class: "col-span-3 flex justify-end items-center space-x-1" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_20 = {
  key: 0,
  class: "truncate px-1.5 py-0.5 rounded-md bg-gray-200 inline-flex align-middle items-center text-xs tracking-tighter text-gray-800 hover:text-gray-900"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 1,
  class: "truncate text-xs text-amber-800 bg-amber-100 px-1.5 py-0.5 rounded-md inline-flex align-middle items-center tracking-tighter hover:text-gray-900"
}
const _hoisted_24 = {
  key: 2,
  class: "truncate text-xs text-green-800 bg-green-200 px-1.5 py-0.5 rounded-md inline-flex align-middle items-center tracking-tighter hover:text-gray-900"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "flex items-center space-x-2 ml-1 truncate"
}
const _hoisted_28 = { class: "truncate flex items-start text-xs text-yellow-800 bg-yellow-100 px-1.5 py-0.5 rounded-md align-middle tracking-tighter hover:text-gray-900" }
const _hoisted_29 = {
  key: 2,
  class: "flex items-center ml-1"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "w-full grid grid-cols-12 mt-4"
}
const _hoisted_32 = {
  key: 0,
  class: "col-span-12 flex justify-center py-4"
}
const _hoisted_33 = {
  key: 1,
  class: "col-span-9"
}
const _hoisted_34 = { class: "grid grid-cols-12" }
const _hoisted_35 = { class: "col-start-3 col-span-9" }
const _hoisted_36 = { class: "w-full mb-2 -ml-2" }
const _hoisted_37 = { class: "bg-gray-200 rounded-lg pb-1 w-full overflow-hidden" }
const _hoisted_38 = { class: "w-full truncate text-gray-700 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline whitespace-no-wrap bg-gray-300 px-2 py-1 flex justify-between" }
const _hoisted_39 = { class: "flex flex-col px-2 py-1 text-gray-600 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight" }
const _hoisted_40 = { class: "leading-5 truncate" }
const _hoisted_41 = { class: "font-semibold text-right" }
const _hoisted_42 = {
  key: 1,
  class: "font-medium ml-1"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 0,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_48 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_49 = {
  key: 2,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_50 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_51 = {
  key: 2,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 3,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold"
}
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { class: "text-gray-500 text-xs leading-5 whitespace-nowrap tracking-tight font-semibold" }
const _hoisted_56 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_57 = {
  key: 4,
  class: "mt-1"
}
const _hoisted_58 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight"
}
const _hoisted_59 = {
  key: 5,
  class: "mt-1"
}
const _hoisted_60 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight"
}
const _hoisted_61 = {
  key: 6,
  class: "mt-1"
}
const _hoisted_62 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight"
}
const _hoisted_63 = {
  key: 7,
  class: "mt-1"
}
const _hoisted_64 = {
  key: 1,
  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight"
}

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {
  CalendarIcon,
  EllipsisHorizontalIcon,
  ExclamationTriangleIcon,
  ReceiptRefundIcon,
  ShoppingBagIcon
} from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import BasicSpinner from '@/components/BasicSpinner.vue'
import RefundModal from '@/components/neue/RefundModal.vue'
import { useDropdownAnchor } from '@/composables/useDropdownAnchor'
import { useEntitlements } from '@/composables/useEntitlements'
import { canOpenTierView } from '@/config/membershipTierView'
import { awaitingInvoicePayment, collectedOutsideStripe } from '@/helpers/orderPayment'
import { maxRefundCentsFor } from '@/helpers/refund'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'BottleRow',
  props: {
  bottle: Object,
  lite: { type: Boolean, default: false }
},
  emits: ['order-status-changed'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const router = useRouter()
const bottle = computed(() => mapRelationship(props.bottle))

const modalOpen = ref(false)
const expanded = ref(false)
const loadingDetails = ref(false)
const detailsLoaded = ref(false)

const { setReference, setFloating, floatingStyles } = useDropdownAnchor({ placement: 'bottom-end' })

const onExpand = async () => {
  expanded.value = !expanded.value

  // In lite mode, lazy-load full details when expanding for the first time
  if (props.lite && expanded.value && !detailsLoaded.value) {
    loadingDetails.value = true
    await api.call(
      'GET',
      `bottles/${props.bottle.id}?included=checkout,store,conversation_user_pair,fulfillment_slot,fulfillment_method,membership_tier,distribution_list,bottle_cycle,bottle_payment,cart,cart.cart_items,cart.cart_items.product`
    )
    detailsLoaded.value = true
    loadingDetails.value = false
  }
}

const payment = computed(() => mapRelationship(bottle.value.relationships.bottle_payment?.data))
const checkout = computed(() => mapRelationship(bottle.value.relationships.checkout.data))
const conversationUserPair = computed(() => mapRelationship(bottle.value.relationships.conversation_user_pair?.data))
const membershipTier = computed(() => mapRelationship(bottle.value.relationships.membership_tier?.data))
const bottleCycle = computed(() => mapRelationship(bottle.value.relationships.bottle_cycle?.data))
const fulfillmentSlot = computed(() => mapRelationship(bottle.value.relationships.fulfillment_slot?.data))
const fulfillmentMethod = computed(() => mapRelationship(bottle.value.relationships.fulfillment_method?.data))
const store = computed(() => mapRelationship(bottle.value.relationships.store?.data))
const cart = computed(() => mapRelationship(bottle.value.relationships.cart?.data))
const cartItems = computed(() => mapRelationships(cart.value.relationships.cart_items?.data))
const bottlePayment = computed(() => mapRelationship(bottle.value.relationships.bottle_payment?.data))
// BOT-1680: placed on an invoice that is still open, so nothing is charged yet.
const awaitingInvoice = computed(() => awaitingInvoicePayment(bottle.value.attributes, bottlePayment.value))
// BOT-1764: settled by the merchant outside Stripe, so nothing was charged.
const markedPaidOutsideStripe = computed(() => collectedOutsideStripe(bottlePayment.value))

const maxRefundCents = computed(() => maxRefundCentsFor(bottlePayment.value, checkout.value))

const dateFormat = new Intl.DateTimeFormat([], { dateStyle: 'medium' })
const timeFormat = new Intl.DateTimeFormat([], { hour: 'numeric', minute: '2-digit' })
const paidDate = computed(() => {
  if (!payment.value) return null
  const created = new Date(payment.value.attributes.created_at)
  return dateFormat.format(created) + ' at ' + timeFormat.format(created)
})

const fulfilledDate = computed(() => {
  if (!fulfillmentSlot.value) return null
  return dateFormat.format(Date.parse(fulfillmentSlot.value.attributes.fulfillment_date + 'T00:00'))
})

const paymentStatus = computed(() => {
  const status = bottle.value.attributes.status
  if (payment.value) {
    const markedAsPaid =
      payment.value.attributes.reason === 'mark_as_paid' || payment.value.attributes.reason == 'less_than_50c'
    if (markedAsPaid && status === 'paid') {
      return 'marked paid'
    }
  }

  if (bottle.value.attributes.cancellation_status !== 'active') {
    return bottle.value.attributes.cancellation_status.replace('_', ' ')
  }

  if (bottle.value.attributes.refund_status !== 'not_refunded') {
    return bottle.value.attributes.refund_status.replace('_', ' ')
  }

  // BOT-1546: an invoice order is placed now and paid when Stripe says so.
  // Sits below the cancellation and refund checks so those states still win.
  if (payment.value?.attributes.reason === 'stripe_invoice') {
    if (status === 'invoiced') return 'invoiced'
    if (status === 'paid') return 'invoice paid'
  }

  return status.replace('-', ' ')
})

const statusColor = computed(
  () =>
    ({
      paid: 'bg-green-100 text-green-800',
      'marked paid': 'bg-green-100 text-green-800',
      invoiced: 'bg-amber-100 text-amber-800',
      'invoice paid': 'bg-green-100 text-green-800',
      expired: 'bg-red-100 text-red-800',
      cancelled: 'bg-red-100 text-red-800',
      benign: 'bg-gray-100 text-gray-700',
      skipped: 'bg-gray-100 text-gray-700'
    })[paymentStatus.value] ?? 'bg-yellow-100 text-yellow-800'
)

const idStatusColor = computed(
  () =>
    ({
      paid: 'bg-green-100 text-green-800',
      'marked paid': 'bg-green-100 text-green-800',
      invoiced: 'bg-amber-100 text-amber-800',
      'invoice paid': 'bg-green-100 text-green-800',
      cancelled: 'bg-red-100 text-red-800'
    })[paymentStatus.value] ?? 'bg-gray-100 text-gray-700'
)

const canReadMessages = computed(() => {
  return privilegeService.canAccessResourceAction('messages', null, 'read')
})

const canReadOrders = computed(() => {
  return privilegeService.canAccessResourceAction('orders', null, 'read')
})

const { user } = useEntitlements()
const canOpenTier = computed(() => canOpenTierView(user.value))
const canReadSell = computed(() => {
  return privilegeService.canAccessResourceAction('sell', null, 'read')
})

const actionOptions = computed(() => {
  const actions = bottle.value.attributes.actions
  const canRead = privilegeService.canAccessResourceAction('orders', null, 'read')
  const canUpdate = privilegeService.canAccessResourceAction('orders', null, 'update')
  const viewEditText = canRead && canUpdate ? 'View/edit order' : 'View order'

  return [
    ...(canRead ? [{ name: viewEditText, value: 'open' }] : []),
    ...(canRead && canUpdate && bottle.value.attributes.link
      ? [{ name: 'Open order as customer', value: 'link' }]
      : []),
    ...(canUpdate && actions.refund ? [{ name: 'Refund order', value: 'refund' }] : []),
    ...(canUpdate && actions.mark_as_paid ? [{ name: 'Mark as paid', value: 'paid' }] : []),
    ...(canUpdate && actions.mark_as_unpaid ? [{ name: 'Mark as unpaid', value: 'unpaid' }] : []),
    ...(canUpdate && actions.cancel_order ? [{ name: 'Cancel order', value: 'cancel' }] : []),
    ...(canUpdate && actions.un_cancel_order ? [{ name: 'Uncancel order', value: 'uncancel' }] : []),
    ...(canUpdate && actions.skip ? [{ name: 'Skip', value: 'skip' }] : []),
    ...(canUpdate && actions.unskip ? [{ name: 'Unskip', value: 'unskip' }] : [])
  ]
})

const selectAction = action => {
  if (action === 'open') {
    router.push(`/order/${bottle.value.id}`)
  }
  if (action === 'link') {
    window.open(bottle.value.attributes.link, '_blank')
  }
  if (action === 'refund') {
    modalOpen.value = true
  }
  if (action === 'paid') {
    api.call('POST', `bottles/${bottle.value.id}/pay`)
  }
  if (action === 'unpaid') {
    // BOT-1764: unmarking an invoice order reissues the invoice; load it with the reply.
    api.call('POST', `bottles/${bottle.value.id}/unpay?included=bottle_invoice,bottle_payment`)
  }
  if (action === 'cancel') {
    api
      .call('PUT', `bottles/${bottle.value.id}`, { bottle: { cancellation_status: 'cancelled' } })
      .then(() => emit('order-status-changed'))
  }
  if (action === 'uncancel') {
    api
      .call('PUT', `bottles/${bottle.value.id}`, { bottle: { cancellation_status: 'active' } })
      .then(() => emit('order-status-changed'))
  }
  if (action === 'skip') {
    api.call('POST', `bottles/${bottle.value.id}/skips`)
  }
  if (action === 'unskip') {
    api.call('POST', `bottles/${bottle.value.id}/unskips`)
  }
}

const refund = amountCents => {
  api.call('POST', `bottles/${bottle.value.id}/refunds`, {
    refund: {
      amount: amountCents
    }
  })
  modalOpen.value = false
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RefundModal, {
      "is-open": modalOpen.value,
      "max-refund-cents": maxRefundCents.value,
      onClose: _cache[0] || (_cache[0] = $event => (modalOpen.value = false)),
      onSubmit: refund
    }, null, 8, ["is-open", "max-refund-cents"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "w-full grid grid-cols-12 items-center align-middle cursor-pointer",
        onClick: onExpand
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (canReadOrders.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: _normalizeClass(["px-1 py-0.5 rounded-md hover:underline", idStatusColor.value]),
                      to: `/order/${bottle.value.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(bottle.value.attributes.display_id), 1)
                      ]),
                      _: 1
                    }, 8, ["class", "to"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["px-1 py-0.5 rounded-md", idStatusColor.value])
                    }, _toDisplayString(bottle.value.attributes.display_id), 3))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (conversationUserPair.value && canReadMessages.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "text-sm font-semibold text-gray-800 hover:underline",
                    to: '/messages/' + conversationUserPair.value.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(conversationUserPair.value.attributes.display_name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (conversationUserPair.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(conversationUserPair.value.attributes.display_name), 1))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              ((fulfillmentMethod.value || store.value) && fulfillmentSlot.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(fulfillmentMethod.value?.attributes?.name) + _toDisplayString(store.value?.attributes?.store_name ? ' at ' + store.value.attributes.store_name : ''), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_unref(ExclamationTriangleIcon), { class: "w-5 h-5 text-yellow-500" })
                  ]))
            ]),
            _createElementVNode("div", _hoisted_12, [
              (fulfillmentSlot.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_unref(CalendarIcon), { class: "w-3 h-3 mr-1" }),
                      _createTextVNode(" " + _toDisplayString(fulfilledDate.value), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createVNode(_unref(ExclamationTriangleIcon), { class: "w-5 h-5 text-yellow-500" })
                  ]))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_unref(ShoppingBagIcon), { class: "w-3 h-3 mr-1" }),
                _createTextVNode(" " + _toDisplayString(cart.value?.attributes?.quantity) + " items ", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (bottlePayment.value?.attributes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (
              bottlePayment.value?.attributes.reason == 'mark_as_paid' ||
              bottlePayment.value?.attributes.reason == 'less_than_50c' ||
              markedPaidOutsideStripe.value
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (bottlePayment.value?.attributes.account_credit_amount.amount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(bottlePayment.value?.attributes.account_credit_amount.format) + " Credit used ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "Marked as paid"))
                    ]))
                  : (awaitingInvoice.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Invoiced "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (bottlePayment.value?.attributes.charged_amount.format)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(bottlePayment.value?.attributes.charged_amount.format) + " charged ", 1))
                          : _createCommentVNode("", true),
                        (bottlePayment.value?.attributes.account_credit_amount.amount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "  & " + _toDisplayString(bottlePayment.value?.attributes.charged_amount.format) + " credit used ", 1))
                          : _createCommentVNode("", true)
                      ]))
              ]))
            : _createCommentVNode("", true),
          (
            bottle.value?.attributes.refund_status == 'fully_refunded' ||
            bottle.value?.attributes.refund_status == 'partially_refunded'
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_unref(ReceiptRefundIcon), { class: "w-4 h-4 mr-1" }),
                  _createTextVNode(" " + _toDisplayString(checkout.value?.attributes.refunded_amount.format), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (bottle.value?.attributes.status === 'skipped')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "truncate text-xs text-yellow-900 bg-yellow-50 px-1.5 py-0.5 rounded-md align-middle tracking-tighter hover:text-gray-900" }, [
                  _createElementVNode("span", null, "Skipped")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_unref(Menu), {
              as: "div",
              class: "relative ml-2 inline-block text-left"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuButton), {
                  ref: _unref(setReference),
                  class: "ml-1 inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-1 text-sm font-medium text-gray-700 shadow-sm shadow-inner shrink-0 transition-all hover:bg-gray-50 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(EllipsisHorizontalIcon), { class: "h-5 w-5" })
                  ]),
                  _: 1
                }, 512),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), {
                        ref: _unref(setFloating),
                        style: _normalizeStyle(_unref(floatingStyles)),
                        class: "z-50 w-56 overflow-y-auto divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionOptions.value, (actionOption) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: actionOption.value,
                              class: "py-1"
                            }, [
                              _createVNode(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm w-full text-left'
                        ]),
                                    onClick: _withModifiers($event => (selectAction(actionOption.value)), ["stop"])
                                  }, _toDisplayString(actionOption.name), 11, _hoisted_30)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (expanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            (__props.lite && loadingDetails.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(BasicSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", null, "Cart (" + _toDisplayString(cart.value?.attributes?.quantity) + " items)", 1),
                            _createElementVNode("div", null, _toDisplayString(cart.value?.attributes?.total_price?.format) + " cart subtotal", 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.id
                              }, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(item.attributes.quantity), 1),
                                  (canReadSell.value)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "font-medium hover:underline ml-1",
                                        to: '/store/products/' + item.relationships.product.data.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(mapRelationship)(item.relationships.product.data).attributes.product_name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(mapRelationship)(item.relationships.product.data).attributes.product_name), 1))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      (bottlePayment.value?.attributes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(paidDate.value), 1),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Payment time", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (bottlePayment.value?.attributes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (
                  bottlePayment.value?.attributes.reason == 'mark_as_paid' ||
                  bottlePayment.value?.attributes.reason == 'less_than_50c'
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                  (bottlePayment.value?.attributes.account_credit_amount.amount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(bottlePayment.value?.attributes.charged_amount.format) + " credit used ", 1))
                                    : (bottlePayment.value?.attributes.reason == 'less_than_50c')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, " Marked as paid because total was less than $0.50 "))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_49, " Marked as Paid "))
                                ]))
                              : (bottlePayment.value?.attributes.reason == 'stripe_invoice')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(bottle.value.attributes.status === 'invoiced'
                    ? 'Invoiced, unpaid'
                    : markedPaidOutsideStripe.value
                      ? 'Marked as paid'
                      : 'Invoice paid'), 1))
                                : (bottlePayment.value?.attributes.charged_amount.format)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                      _createTextVNode(" Charged " + _toDisplayString(bottlePayment.value?.attributes.charged_amount.format) + " ", 1),
                                      (bottle.value.value?.attributes.actions.refund)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode("  -  ", -1),
                                            _createElementVNode("button", null, "Refund", -1)
                                          ]))]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, " Paid ")),
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Payment method", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (
                bottle.value?.attributes.refund_status == 'fully_refunded' ||
                bottle.value?.attributes.refund_status == 'partially_refunded'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("span", _hoisted_55, _toDisplayString(checkout.value?.attributes.refunded_amount.format), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Refund", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (fulfillmentSlot.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createVNode(_component_router_link, {
                              to: '/lists/' + fulfillmentSlot.value.relationships.audience_for_date.data?.id,
                              class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(fulfilledDate.value), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Production day", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (fulfillmentMethod.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            (canReadSell.value)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: '/store/fulfillment-methods/' + fulfillmentMethod.value.id,
                                  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(fulfillmentMethod.value.attributes.name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(fulfillmentMethod.value.attributes.name), 1)),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Method", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (membershipTier.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (canOpenTier.value)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: '/store/membership-tiers/' + membershipTier.value.id,
                                  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(membershipTier.value.attributes.tier_name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(membershipTier.value.attributes.tier_name), 1)),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Membership", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (bottleCycle.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            (canReadSell.value)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: '/store/drops/' + bottleCycle.value.id,
                                  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(bottleCycle.value.attributes.description), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(bottleCycle.value.attributes.description), 1)),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Drop", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (store.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            (canReadSell.value)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: '/store/stores/' + store.value.id,
                                  class: "text-gray-500 text-xs leading-5 whitespace-nowrap font-semibold tracking-tight hover:underline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(store.value.attributes.store_name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(store.value.attributes.store_name), 1)),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-xxs font-manrope uppercase tracking-wider text-gray-500" }, "Store", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

}